import * as actionTypes from './stateActionTypes';

export const setHiveFetchActivated = (fetchActivated) => ({type: actionTypes.SET_HIVE_FETCH_ACTIVATED, fetchActivated:fetchActivated});
export const setHive = (hive) => ({type: actionTypes.SET_HIVE, hive:hive});
export const setAGVFetchActivated = (fetchActivated) => ({type: actionTypes.SET_AGV_FETCH_ACTIVATED, fetchActivated:fetchActivated});
export const setAgvs = (agvs) => ({type: actionTypes.SET_AGVS, agvs:agvs});